export default "__VITE_ASSET__hVOxmeuF__"